import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mmI18nRequiredMessage'
})
export class I18nRequiredMessagePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
